/**************************************************
 * Nombre:       Tarjeta_Fila
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";


const Tarjeta_Fila = ({item,click}) => {

    return (
        <Grid
            onClick={() => click(item)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                p: 2,
                backgroundColor: theme.palette.primary.main,
                color: '#fff',
                borderRadius: 2,
                cursor: 'pointer',
            }}
        >

            <Grid container size={{xs: 10, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                <Typography>{item.consecutivo + ' - ' + item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 2, sm: 12, md: 2}} sx={{justifyContent: 'flex-end'}}>
                <Typography>{item.numPersonas}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Fila